<template>
  <div class="bi-cohorts">
    <bi-cohorts-filter
      :entities="entities"
      :affiliates="affiliates"
      :is-loading="isLoading"
      :is-loading-affiliates="isLoadingAffiliates"
      @request-affiliates="$emit('request-affiliates', $event)"
      @request-report="$emit('request-report', $event)"
      @show-help="isHelpDisplayed = true"
    />

    <bi-cohort-analysis
      v-if="report"
      :report="report"
      :report-settings="reportSettings"
      :is-loading="isLoading"
    />

    <v-dialog v-model="isHelpDisplayed" max-width="900">
      <bi-cohorts-help />
    </v-dialog>
  </div>
</template>

<script>
import BiCohortsFilter from './BiCohortsFilter.vue';
import BiCohortAnalysis from './BiCohortAnalysis.vue';
import BiCohortsHelp from './BiCohortsHelp.vue'

export default {
  components: {
    BiCohortsFilter,
    BiCohortAnalysis,
    BiCohortsHelp
  },
  props: {
    isLoading: Boolean,
    isLoadingAffiliates: Boolean,
    entities: {
      type: Array,
      default: () => ([])
    },
    affiliates: {
      type: Array,
      default: () => ([])
    },
    report: {
      type: Array,
      default: () => ([])
    },
    reportSettings: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isHelpDisplayed: false,
    }
  }
}
</script>
